import { CommonModule } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Component, ElementRef, Input, input, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { avmRentalConfig, commercialRentalConfig, apartmentSaleAvmConfig, AvmDataConfig, NearByDataConfig ,BuildingsConfig, FloorsConfig, UnitsConfig, TransactionsConfig, AvmApiConfig, NearbyApiDataConfig} from './form-config';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { GlobalContants } from 'src/app/constants/global.contants';
import { UserService } from 'src/app/services/user.service';
import { SharedService } from 'src/app/services/shared.service';
import { AlertService } from 'src/app/services/alert.service';
import { ApiService } from 'src/app/services/api.service';
import { LoaderComponent } from '../../common/loader';
import { apiEndPoints } from 'src/app/constants/api-endpointsconstant';
import { ResponseAvmRentalComponent } from './response-view/response-avm-rental/response-avm-rental.component';
import { ResponseAvmDataComponent } from './response-view/response-avm-data/response-avm-data.component';
import { ResponseCommercialDataComponent } from './response-view/response-commercial-data/response-commercial-data.component';
import { ResponseCommercialRentalComponent } from './response-view/response-commercial-rental/response-commercial-rental.component';
import { ResponseNearbyDataComponent } from './response-view/response-nearby-data/response-nearby-data.component';
import { ResponseBuildingsDataComponent } from './response-view/response-buildings-data/response-buildings-data.component';
import { ResponseFloorsDataComponent } from './response-view/response-floor-data/response-floors-data.component';
import { ResponseUnitsDataComponent } from './response-view/response-unit-data/response-units-data.component';
import { ResponseTransactionsDataComponent } from './response-view/response-transaction-data/response-transactions-data.component';
import { DataType } from 'src/app/constants/enum';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { MapDailogComponent } from '../../common/map-dailog/map-dailog.component';
import { LatLon } from '../../common/model/latlon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ResponseAvmApiComponent } from './response-view/response-avm-api/response-avm-api.component';
import { ResponseNearbyApiComponent } from "./response-view/response-nearby-api/response-nearby-api.component";

export const YEAR_MODE_FORMATS = {
  parse: {
    dateInput: 'DD-MMM-YYYY',
  },
  display: {
    dateInput: 'DD-MMM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-api-ui-response',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, FormsModule, ReactiveFormsModule,
    LoaderComponent,
    ResponseAvmDataComponent,
    ResponseNearbyDataComponent,
    ResponseCommercialDataComponent,
    ResponseAvmRentalComponent,
    ResponseCommercialRentalComponent,
    ResponseBuildingsDataComponent,
    ResponseFloorsDataComponent,
    ResponseUnitsDataComponent,
    ResponseTransactionsDataComponent,
    ResponseAvmApiComponent,
    MatTooltipModule, ResponseNearbyApiComponent],
  templateUrl: './api-ui-response.component.html',
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: YEAR_MODE_FORMATS },
  ],
})
export class ApiUIResponseComponent {
  @Input() type :String = "";

  DataType = DataType;

  formConfig:any;
  form: FormGroup;

  api_end_point = ``;
  apiBaseUrl = ``;
  response: any;
  loader: boolean;
  user_token:string ='';
  api_key:string='';
  selected_view='Params';
  is_requested:boolean=false;
  city_code:string ='';
   minStartDate = new Date(1970, 0, 1);

   start_date='';
   end_date='';

   start_date_f ='';
   end_date_f ='';
   categoriesOptions: { label: string; value: number }[] = [];
    hasAccess: boolean = false;  // For category dropdown only

  constructor(private fb: FormBuilder,
    private userService: UserService,
        private sharedService: SharedService,
        private alertService:AlertService,
        private apiService:ApiService,
        private matdailog: MatDialog
  ) {}

  changeSelection(value:string){
    this.selected_view = value;
  }

  ngOnInit(): void {
    if(this.type === 'avmRental'){
      this.formConfig = avmRentalConfig;
      this.api_end_point = `${environment.apiBaseUrl}${apiEndPoints.avmRental}`;
      this.apiBaseUrl = `${environment.apiBaseUrl}${apiEndPoints.avmRental}`;
    }else if(this.type === 'commercial') {
      this.formConfig = commercialRentalConfig
      this.api_end_point = `${environment.apiBaseUrl}${apiEndPoints.commercialRental}`;
      this.apiBaseUrl = `${environment.apiBaseUrl}${apiEndPoints.commercialRental}`;
    }else if(this.type === 'apartment') {
      this.formConfig = apartmentSaleAvmConfig
      this.api_end_point = `${environment.apiBaseUrl}${apiEndPoints.apartmentSaleAvm}`;
      this.apiBaseUrl = `${environment.apiBaseUrl}${apiEndPoints.apartmentSaleAvm}`;
    }else if(this.type === 'avm_data') {
      this.formConfig = AvmDataConfig
      this.api_end_point = `${environment.apiBaseUrl}${apiEndPoints.avmData}`;
      this.apiBaseUrl = `${environment.apiBaseUrl}${apiEndPoints.avmData}`;
    }else if(this.type === 'nearby_data') {
      this.formConfig = NearByDataConfig
      this.api_end_point = `${environment.apiBaseUrl}${apiEndPoints.nearbyData}`;
      this.apiBaseUrl = `${environment.apiBaseUrl}${apiEndPoints.nearbyData}`;
    }else if(this.type === 'office_property') {
      this.formConfig = AvmDataConfig
      this.api_end_point = `${environment.apiBaseUrl}${apiEndPoints.officeProperty}`;
      this.apiBaseUrl = `${environment.apiBaseUrl}${apiEndPoints.officeProperty}`;
    }else if(this.type === 'buildings') {
      this.formConfig = BuildingsConfig
      this.api_end_point = `${environment.apiBaseUrl}${apiEndPoints.buildings}`;
      this.apiBaseUrl = `${environment.apiBaseUrl}${apiEndPoints.buildings}`;
    }else if(this.type === 'floors') {
      this.formConfig = FloorsConfig
      this.api_end_point = `${environment.apiBaseUrl}${apiEndPoints.floors}`;
      this.apiBaseUrl = `${environment.apiBaseUrl}${apiEndPoints.floors}`;
    }else if(this.type === 'units') {
      this.formConfig = UnitsConfig
      this.api_end_point = `${environment.apiBaseUrl}${apiEndPoints.units}`;
      this.apiBaseUrl = `${environment.apiBaseUrl}${apiEndPoints.units}`;
    }else if(this.type === 'transactions') {
      this.formConfig = TransactionsConfig
      this.api_end_point = `${environment.apiBaseUrl}${apiEndPoints.transactions}`;
      this.apiBaseUrl = `${environment.apiBaseUrl}${apiEndPoints.transactions}`;
    }else if(this.type === 'avm_api') {
      this.formConfig = AvmApiConfig
      this.api_end_point = `${environment.apiBaseUrl}${apiEndPoints.avmApi}`;
      this.apiBaseUrl = `${environment.apiBaseUrl}${apiEndPoints.avmApi}`;
    }else if(this.type === 'nearby_apidata') {
      this.formConfig = NearbyApiDataConfig
      this.api_end_point = `${environment.apiBaseUrl}${apiEndPoints.nearby}`;
      this.apiBaseUrl = `${environment.apiBaseUrl}${apiEndPoints.nearby}`;
    }

    const group: any = {
      construction: new FormControl(),
      unit: new FormControl(),
      property: new FormControl(),
    };
    this.formConfig.params.forEach((field:any) => {
      group[field.attribute] =  new FormControl(field?.default || '', field?.required ? Validators.required: null);
    });
    this.formConfig.filters?.forEach((field:any) => {
      group[field.attribute] = [field?.default || ''];
    });
    this.form = this.fb.group(group);
    this.getAPIKey();
    this.getToken();
  }

  onChange(){

    let payload: any = { ...this.form.value };
    
    // Map keys to update dynamically
    const mapFields = ['construction', 'unit', 'property'];

    mapFields.forEach(key => {
      const value = payload[key];
      if (value) {
        payload[value] = 1;
      }
      delete payload[key];
    });

    if(payload.date){
      payload.date =  moment(new Date(payload.date)).format('YYYY-MM-DD');
    }

    let sDate, eDate, finalDate = "";
    let sDateF, eDateF, finalDateFirst = "";
    if(this.end_date < this.start_date) {
      this.end_date = "";
    }

    if(this.start_date_f) sDateF = moment(new Date(this.start_date_f)).format('YYYY-MM-DD');
    if(this.end_date_f) eDateF = moment(new Date(this.end_date_f)).format('YYYY-MM-DD');

    if(sDateF && eDateF) {
      finalDateFirst = `${sDateF}to${eDateF}`;
    }else if(sDateF) {
      finalDateFirst = `${sDateF}to`
    }else if(eDateF) {
      finalDateFirst = `to${eDateF}`;
    }
    
    if(this.start_date) sDate = moment(new Date(this.start_date)).format('YYYY-MM-DD');
    if(this.end_date) eDate = moment(new Date(this.end_date)).format('YYYY-MM-DD');

    if(sDate && eDate) {
      finalDate = `${sDate}to${eDate}`;
    }else if(sDate) {
      finalDate = `${sDate}to`
    }else if(eDate) {
      finalDate = `to${eDate}`;
    }
    
    payload.transaction_date = finalDate;
    payload.date = finalDateFirst;

      const params = Object.entries(payload)
      .filter(([_, value]) => value !== undefined && value !== null && value !== '' && value !== '0')
      .map(([key, value]) => `${key}=${value}`)
      .join('&');

      this.api_end_point = `${this.apiBaseUrl}?${params}`;
  }

  restrictNegativeAndZero(event: KeyboardEvent) {
    const invalidKeys = ['-'];
    if (invalidKeys.includes(event.key)) {
      event.preventDefault();
    }
  }


  
  onSubmit() {
    if (this.loader) return;
    if ((this.type === 'buildings' || this.type === 'floors' || this.type === 'units' || this.type === 'transactions' || this.type === 'avm_api'
       ) && !this.city_code?.trim()) {
      this.alertService.warning("City Code is required");
      return;
    }
    if(this.type === 'avm_api'){
      if (!this.form.value['parcel_uid']?.trim() && !this.form.value['property_uid']?.trim()) { 
         this.alertService.warning("Property UID or Parcel UID is required");
        return;
      }
    }
    let inputparam = this.formConfig.params.find((e: any) => e.attribute == 'lat')
    if (inputparam?.required) {
      if (!this.form.value['lat'] || !this.form.value['lon']) {
        this.alertService.warning("Enter Latitude and Longitude");
        return;
      }
    }
    if (this.type === 'nearby_apidata' && !this.form.value['distance']) {
      this.alertService.warning("Distance is required");
      return;
    }
    if (this.type === 'nearby_apidata' && !this.form.value['category']) {
      this.alertService.warning("Category is required");
      return;
    }

    if(this.form.value['limit'] > 100){
      this.alertService.warning("Limit cannot be greater than 100");
      return;
    }
    let payload: any = { ...this.form.value };

    // Map keys to update dynamically
    const mapFields = ['construction', 'unit', 'property'];

    mapFields.forEach(key => {
      const value = payload[key];
      if (value) {
        payload[value] = 1;
      }
      delete payload[key];
    });

    if(this.start_date_f && this.end_date_f){
      let aa=moment(new Date(this.start_date_f)).format('YYYY-MM-DD')
      let bb=moment(new Date(this.end_date_f)).format('YYYY-MM-DD')
      payload.date = `${aa}to${bb}`;
    }
    if(this.start_date && this.end_date){
      let a=moment(new Date(this.start_date)).format('YYYY-MM-DD')
      let b=moment(new Date(this.end_date)).format('YYYY-MM-DD')
      payload.transaction_date = `${a}to${b}`;
    }
        
    let apiEndPoint = '';
    if (this.type == 'avmRental' || this.type == 'commercial') {
      const lat = payload.lat;
      const lon = payload.lon;
      delete payload.lat;
      delete payload.lon;
      Object.keys(payload).forEach(key => {
        if (payload[key] === undefined || payload[key] === null || payload[key] === '' || payload[key] === '0') {
          delete payload[key];
        }
      })
      apiEndPoint = `${this.apiBaseUrl}?lat=${lat}&lon=${lon}&filter=${encodeURIComponent(JSON.stringify(payload))}`;
    } else {
      const params = Object.entries(payload)
        .filter(([_, value]) => value !== undefined && value !== null && value !== '' && value !== '0')
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
      apiEndPoint = `${this.apiBaseUrl}?${params}`;
    }

    

      this.loader = true;
      this.apiService.getAVMRental(apiEndPoint,this.api_key,this.user_token, this.city_code).subscribe({
        next: (res)=>{
          this.is_requested = true;
          this.loader = false;
          this.selected_view = 'Response';
          if(res && res.status == 200){
            this.response = res.data;
          }else{
            this.response =null;
            this.alertService.error(res?.message)
          }
        },
        error:(error)=>{
          this.selected_view = 'Response';
          this.is_requested = true;
          this.loader = false;
          this.response = null;
          this.alertService.error(error.error.message)
        }
      })

  }

  cleartext(param: string, attr: string) {

    if (param == 'date-range') {
      if (attr == 'date') {
        this.start_date_f = '';
        this.end_date_f = '';
      } else if (attr == 'transaction_date') {
        this.start_date = '';
        this.end_date = '';
      }
    }
    if (param == 'date') {
      this.form.patchValue({
        date: ''
      })
    }

    this.onChange();
  }

    /**
     * Get API key
     */
    getAPIKey(){
      let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
      let company_id = userInfo?.company_details?.company_id;
      this.userService.getAPIKey(Number(company_id)).subscribe({
        next: (res: any) => {
          if (res.status == 200 && res.data[0]) {
            this.api_key = res.data[0].api_key;
          }else{
            this.api_key = '';
          }
        },
        error: (err) => {
          this.api_key = '';
        }
      })
    }

    /**
     * Get Token
     */
    getToken(){
      //logged in user token
      let token = this.sharedService.getStoreValue(GlobalContants.StoreKey.userToken)
      let body = {
        token : token,
        is_refresh : false
      };
      this.userService.updateToken(body).subscribe({
        next:((res:any)=>{
          if(res.status == 201){
            this.user_token = res.data;
          }else{
            this.user_token ='';
          }
        })
        ,error:(err)=>{
          this.user_token ='';
          this.alertService.error(err.error.message)
        }
      })
    }

    openMapBox() {
      let latlon:any = {
        lat: Number(this.form.get('lat')?.value),
        lng: Number(this.form.get('lon')?.value)
      }
      this.matdailog.open(MapDailogComponent, {
        width: '75%',
        height: 'auto',
        data: { latlng: latlon }
      }).afterClosed().subscribe((res: LatLon) => {
        if (res) {
          this.updateFormlatlonValue(res);
        }
      })
    }

    updateFormlatlonValue(latlon:LatLon){
      this.form.patchValue({
          lat: latlon.lat.toFixed(9),
          lon: latlon.lng.toFixed(9)
        })

        this.onChange();
    }
}
